import { palette } from './theme/palette.mjs';
import rgb from './theme/rgb.mjs';
import MdRipple from '../directives/mdRipple.vue';
import VdlResizeObserver from '../directives/vdlResizeObserver.vue';
const DEFAULT_THEME_COLORS = {
    primary: 'indigo',
    accent: 'pink',
    background: 'white',
    warn: 'deep-orange'
};
const DEFAULT_THEME_ASSETS = {
    logoBranded: '/src/assets/logo-branded-default.png',
    logoBrandedDark: '/src/assets/logo-branded-default-dark.png',
    backgroundDrawerBranded: '/src/assets/background-drawer-default.svg',
    backgroundDrawerBrandedDark: '/src/assets/background-drawer-dark-default.svg'
};
class VueTheme {
    name;
    spec;
    app;
    constructor(name, spec, app) {
        this.name = name;
        this.spec = spec;
        this.app = app;
        this.updateStyleElement();
    }
    getAsset(asset) {
        const assets = this.spec.assets || DEFAULT_THEME_ASSETS;
        return assets[asset];
    }
    getColor(type, colorType, hue, inRgb) {
        let color;
        let colorVariant = +hue === 0 ? 500 : hue;
        type = type.toLowerCase();
        if (this.spec[type]) {
            if (typeof this.spec[type] === 'string') {
                color = palette[this.spec[type]];
            }
            else {
                color = palette[this.spec[type].color] || palette[DEFAULT_THEME_COLORS[type]];
                colorVariant = +hue === 0 ? this.spec[type].hue : hue;
            }
        }
        else {
            color = palette[DEFAULT_THEME_COLORS[type]];
        }
        if (colorType === 'color') {
            let isDefault = palette[this.spec[type]];
            if (!colorVariant && !isDefault) {
                if (type === 'accent') {
                    colorVariant = 'A200';
                }
                else if (type === 'background') {
                    colorVariant = 50;
                }
            }
            return inRgb ? rgb(color[colorVariant]) : color[colorVariant];
        }
        let isDarkText = color.darkText.indexOf(colorVariant) >= 0;
        if (this.spec[type] && typeof this.spec[type] !== 'string' && this.spec[type].textColor) {
            if (this.spec[type].textColor === 'black') {
                isDarkText = true;
            }
            else if (this.spec[type].textColor === 'white') {
                isDarkText = false;
            }
        }
        if (isDarkText) {
            return inRgb ? '0, 0, 0' : 'rgba(0, 0, 0, .9)';
        }
        return inRgb ? '255, 255, 255' : 'rgba(255, 255, 255, .87)';
    }
    getStyles() {
        const data = Object.keys(DEFAULT_THEME_COLORS).reduce((ant, type) => {
            ['color', 'contrast'].forEach((colorType) => {
                ant[`--md-${type}-${colorType}`] = this.getColor(type, colorType, '', false);
                ant[`--md-${type}-${colorType}-rgb`] = this.getColor(type, colorType, '', true);
            });
            ['500'].forEach((hue) => {
                ant[`--md-${type}-color-${hue}`] = this.getColor(type, 'color', hue, false);
                ant[`--md-${type}-color-${hue}-rgb`] = this.getColor(type, 'color', hue, true);
            });
            ['200', '400', '600', '800'].forEach((hue) => {
                ant[`--md-${type}-color-${hue}`] = this.getColor(type, 'color', hue, false);
            });
            return ant;
        }, {});
        // custom
        [{
                type: 'accent',
                color: 'contrast',
                hue: 'A100'
            }, {
                type: 'accent',
                color: 'color',
                hue: 'A100'
            }].forEach((e) => {
            data[`--md-${e.type}-${e.color}-${e.hue}`] = this.getColor(e.type, e.color, e.hue, false);
            data[`--md-${e.type}-${e.color}-${e.hue}-rgb`] = this.getColor(e.type, e.color, e.hue, true);
        });
        return data;
    }
    updateStyleElement() {
        const style = this.getStyles();
        const data = Object.keys(style).map(k => `${k}: ${style[k]};`).join('');
        const content = `.md-theme-${this.name}{ ${data} }`;
        this.app.config.globalProperties.$head.push({
            style: [{
                    children: content
                }]
        });
    }
}
;
export default class VueMaterial {
    app;
    themes = {
        default: DEFAULT_THEME_COLORS
    };
    default = 'default';
    registerTheme(name, spec) {
        if (typeof name === 'string') {
            this.themes[name] = new VueTheme(name, spec, this.app);
        }
        else {
            Object.keys(name).forEach((k) => this.themes[k] = new VueTheme(k, name[k], this.app));
        }
        // if (browser.isBrowser) {
        // this.app.config.globalProperties.$head.updateDOM();
        // }
    }
    getDefaultTheme() {
        return this.default;
    }
    setDefaultTheme(name) {
        if (this.themes[name]) {
            // remove previous class
            this.default = name;
            // document.body.className = this.getTheme(name);
        }
        this.app.config.globalProperties.$head.push({
            bodyAttrs: {
                class: this.getThemeClass(this.default)
            }
        });
        // if (browser.isBrowser) {
        // this.app.config.globalProperties.$head.updateDOM();
        // }
    }
    getTheme(name) {
        return this.themes[name || this.default] || this.themes[this.default];
    }
    getThemeClass(name) {
        return name ? `md-theme md-theme-${name}` : 'md-theme';
    }
    install(app) {
        app.provide('$material', this);
        // TODO: the unplugin-vue-components is not installing correctly directives, 
        // check this in new versions to see if it was solved
        app.directive('md-ripple', MdRipple);
        app.directive('resize-observer', VdlResizeObserver);
        this.app = app;
    }
}
//# sourceMappingURL=VueMaterial.mjs.map